const KEY = 'slbk-compare-tray'

export const MAX_COMPARE = 4

function snapshot(card) {
  return {
    id: card.id,
    name: card.name,
    locked: Boolean(card.locked),
    attr_count: card.attr_count,
    attrs: Array.isArray(card.attrs) ? card.attrs : [],
    metrics: card.metrics || null,
    prices: Array.isArray(card.prices) ? card.prices : [],
    summary: card.summary || ''
  }
}

export function readTray() {
  try {
    const raw = sessionStorage.getItem(KEY)
    const list = raw ? JSON.parse(raw) : []
    if (!Array.isArray(list)) return []
    return list.filter((card) => card && card.id != null).slice(0, MAX_COMPARE)
  } catch (e) {
    return []
  }
}

export function writeTray(cards) {
  const next = (cards || []).filter((card) => card && card.id != null).slice(0, MAX_COMPARE)
  sessionStorage.setItem(KEY, JSON.stringify(next))
  return next
}

export function toggleTrayCard(card) {
  const list = readTray()
  const idx = list.findIndex((item) => item.id === card.id)
  if (idx >= 0) {
    list.splice(idx, 1)
    return writeTray(list)
  }
  if (list.length >= MAX_COMPARE) return list
  list.push(snapshot(card))
  return writeTray(list)
}

export function removeTrayCard(id) {
  return writeTray(readTray().filter((card) => card.id !== id))
}

export function replaceTray(cards) {
  return writeTray(cards.map(snapshot))
}

/** 同一张卡再次出现且参数更全时，用新结果替换栏里的预览。 */
export function refreshTrayFromResults(cards) {
  const list = readTray()
  let changed = false
  cards.forEach((card) => {
    const idx = list.findIndex((item) => item.id === card.id)
    if (idx < 0) return
    const prev = list[idx]
    const prevN = (prev.attrs || []).length
    const nextN = (card.attrs || []).length
    if (nextN > prevN || (prev.locked && !card.locked)) {
      list[idx] = snapshot(card)
      changed = true
    }
  })
  return changed ? writeTray(list) : list
}
